import { render, staticRenderFns } from "./OtherServices.vue?vue&type=template&id=e8c7fdba"
import script from "./OtherServices.vue?vue&type=script&lang=js"
export * from "./OtherServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports